import axios from 'src/utils/axios';
import { requests } from '../constants/config';
//import { getComapanyNames } from './companyNamesActions';
import { SESSION_SET_VENDOR_ID } from './sessionActions';
import { useDispatch, useSelector } from 'react-redux';

export const SESSION_VENDOR_REQUEST = 'SESSION_VENDOR_REQUEST';
export const SESSION_VENDOR_SUCCESS = 'SESSION_VENDOR_SUCCESS';
export const SESSION_VENDOR_FAIL = 'SESSION_VENDOR_FAIL';

export const getVendorData = (search = null,correo) => async (dispatch) => {
    dispatch({ type: SESSION_VENDOR_REQUEST });

    if (search) {
        const config = {
            method: 'get',
            url: requests.changeVendor + search
        };
        try {
            const { data } = await axios(config);
            dispatch({ type: SESSION_VENDOR_SUCCESS, payload: data });
            dispatch({ type: SESSION_SET_VENDOR_ID, payload: search });
            localStorage.setItem('selectedVendorId', search);
        } catch (error) {
            dispatch({
                type: SESSION_VENDOR_FAIL,
                payload: error.response && error.response.data.error_description
                    ? error.response.data.error_description
                    : 'Ocurrió un error'
            });
        }
    } else {
                   
        try {
          const config = {
                method: 'get',
                url: requests.basicInfoProveedor
            };
            const { data } = await axios(config);
            localStorage.setItem('vendorData', JSON.stringify(data.data));
            dispatch({ type: SESSION_VENDOR_SUCCESS, payload: data });
             /* dispatch(getComapanyNames(data.data.custentity_be_rfc_sat));*/
             if(correo != undefined){
                dispatch(getComapanyNames(correo));
             }
        } catch (error) {
            dispatch({
                type: SESSION_VENDOR_FAIL,
                payload: error.response && error.response.data.error_description
                    ? error.response.data.error_description
                    : 'Ocurrió un error'
            });
        }
    }
};
